import { Box, type BoxProps, styled } from '@mui/material';
import { forwardRef } from 'react';

import type { TCardId } from '../../types';
import { CardRenderer } from '../body/cards/CardRenderer';

type DraggingCardsPreviewProps = BoxProps & {
  draggingCardIds: TCardId[];
};

export const DraggingCardsPreview = forwardRef(
  ({ draggingCardIds, ...props }: DraggingCardsPreviewProps, ref) => (
    <DraggingCardsContainer {...props} draggingCardIds={draggingCardIds} ref={ref}>
      {draggingCardIds.map((cardId) => (
        <CardRenderer key={cardId} cardId={cardId} />
      ))}
    </DraggingCardsContainer>
  ),
);

const DraggingCardsContainer = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== 'draggingCardIds',
})<DraggingCardsPreviewProps>(
  ({ theme, draggingCardIds }) => `
    position: relative;
    z-index: ${theme.zIndex.tooltip + 1};
    transform: rotate(4deg);

    & > [data-slot="card"] {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      pointer-events: none;
    }

    ${draggingCardIds
      .map(
        (_cardId, index) => `& > [data-slot="card"]:nth-of-type(${index + 1}) {
      z-index: ${draggingCardIds.length - index};
      transform: translate(${index * 2}px, ${index * 46}px);
    }`,
      )
      .join('\n')}
`,
);
